import type { ReactNode } from "react";

interface SectionHeadProps {
  no: string;
  kicker: string;
  title: string;
  sub?: string;
  right?: ReactNode;
}

export default function SectionHead({ no, kicker, title, sub, right }: SectionHeadProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div className="flex items-start gap-3.5">
        <span className="mt-1 grid h-11 w-11 shrink-0 place-items-center bg-foreground-950 text-lg font-black text-background-50">
          {no}
        </span>
        <div>
          <p className="flex items-center gap-2 text-[11px] font-bold tracking-[0.2em] text-primary-600">
            <span className="h-3 w-3 bg-primary-500" />
            {kicker}
          </p>
          <h2 className="font-heading mt-1 text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            {title}
          </h2>
          {sub && <p className="mt-1.5 text-sm text-secondary-600">{sub}</p>}
        </div>
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}